<template>
  <vs-card>
    <div class="vx-row pt-5 px-5">
      <div class="vx-col w-full px-8">
        <form method="POST" @submit.prevent="save_changes">
          <div class="vx-row">
            <!-- Title -->
            <div class="vx-col w-full mb-2 -ml-3">
              <vs-input
                icon-pack="feather"
                class="w-full"
                v-model="form.title"
                :label="`Book Header Title *`"
                placeholder="Pralaya Payodhi Jale"
                name="title"
                id="title"
                v-validate="'required|exclude_special_char'"
                data-vv-as="Book Header Title"
              />
              <span class="text-danger text-sm" v-if="errors.has('title')">{{ errors.first('title') }}</span>
            </div>
            <vs-divider class="mx-4"></vs-divider>
          </div>
          <!-- Save & Reset Button -->
          <div class="vx-row pt-5 px-5 text-center">
            <div class="vx-col w-full">
              <!-- BUTTON -->
              <div class="items-center">
                <vs-button class="vs-con-loading__container mr-2 bg-[#1f4e79]" id="create" @click="save_changes">
                  {{ $route.params.headerId ? 'Update' : 'Add' }}
                </vs-button>
                <vs-button color="danger" @click="navigateList">Cancel</vs-button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </vs-card>
</template>

<script>
import { mapActions, mapState } from 'vuex'

export default {
  name: 'AddUpdate',

  data() {
    return {
      updatedContentLine: null,
      openSections: [], // Open the first section by default
      apiData: [],
      form: {
        title: '',
        book: null
      },
      loading: false, // Add a loading flag to prevent multiple API calls,
      breadcrumb: []
    }
  },

  computed: {
    ...mapState('header', ['createLoading', 'pauriRecord']),
    validateForm() {
      return !this.errors.any()
    }
  },

  methods: {
    ...mapActions('header', {
      show: 'show',
      updateSingleLine: 'updateSingleLine',
      update: 'update',
      create: 'create'
    }),

    /** Save that changes / Update Record */
    async save_changes() {
      if (!(await this.$validator.validate())) {
        this.$vs.notify({
          title: 'Error',
          text: 'Please fix the error first',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          position: 'top-center',
          time: 5000,
          color: 'primary'
        })
        return false
      }
      try {
        let response
        if (this.$route.params.headerId) {
          response = await this.update({
            id: this.$route.params.headerId,
            data: { title: this.form.title }
          })
        } else {
          response = await this.create(this.form)
        }

        // let response = await this.update(this.form)
        this.$router.push({
          name: 'header',
          params: { id: this.form.book } // Replace `yourIdValue` with the actual value for the id
        })
        // this.$emit('update-data', true)
        this.$vs.notify({
          title: 'Success',
          text: response.message,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          position: 'top-center',
          time: 5000,
          color: 'success'
        })
      } catch ({ message }) {
        this.$vs.notify({
          title: 'Error',
          // text: message,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          position: 'top-center',
          time: 5000,
          color: 'primary'
        })
      }
    },

    /** Navigate to Pauries List */
    navigateList() {
      this.$vs.dialog({
        type: 'confirm',
        color: 'primary',
        title: `Confirm Cancel`,
        text: `Are you sure you want to cancel?`,
        accept: () => {
          this.$router.push(`/book/${this.form.book}/header`)
        },
        acceptText: 'Yes',
        cancelText: 'No'
      })
    }
  },

  /** On Load */
  async mounted() {
    const id = this.$route.params.id
    if (id) {
      await this.$store.dispatch('book/show', id).then(async (res) => {
        const parentData = res.data.data
        // /** Get Seocnd ID for Pass in Detail API */
        this.form.book = id

        if (this.$route.params.headerId) {
          this.$store.dispatch('header/show', this.$route.params.headerId).then(async (res) => {
            const data = res.data.data
            /** API call for get detail */
            this.form.title = data && data.title
            /** Pass data for transform Object */

            this.breadcrumb = [
              { title: 'Dashboard', url: '/dashboard' },
              { title: 'Book', url: '/book/list' },
              { title: parentData.title, url: `/book/${id}/header` },
              { title: `Edit ${this.form.title}`, active: true }
            ]
          })
        } else {
          this.breadcrumb = [
            { title: 'Dashboard', url: '/dashboard' },
            { title: 'Book', url: '/book/list' },
            { title: parentData.title, url: `/book/${id}/header` },
            { title: `Add Book Header`, active: true }
          ]
        }
      })
    }
  },

  /** watch */
  watch: {
    breadcrumb(newvalue) {
      this.$emit('update-breadcrumb', newvalue)
    },
    createLoading() {
      if (this.createLoading) {
        this.$vs.loading({
          container: '#create',
          scale: 0.45
        })
      } else {
        this.$vs.loading.close('#create > .con-vs-loading')
      }
    }
  }
}
</script>

<style>
.rotate-180 {
  transform: rotate(180deg);
  transition-duration: 3s;
}

.clr {
  color: #1f4e79;
}

.brd1 {
  border: none !important;
}

.brd {
  background-image: linear-gradient(to left, #5381ac, #215483);
}

/* Add your custom placeholder color here */
textarea::placeholder {
  color: #b0bec5;
  /* Light color for the placeholder */
  font-weight: 200;
}

/* Optional: additional styles */
input,
textarea {
  border: 1px solid rgb(255, 255, 255);
  font-weight: 600;
}
</style>
